export default () => ({
    page: 1,
    loading: false,
    buttonShow: true,
    error: '',
    hash: '',

    init() {
        if (this.count === Object.keys(this.items).length) {
            this.buttonShow = false;
        }
    },

    button: {
        [':class']() {
            return this.loading ? 'disabled' : '';
        },

        ['x-show']() {
            return this.buttonShow
        },

        ['@click']() {
            this.submit();
        },
    },

    async submit() {
        this.page++;
        this.loading = true;

        let response = await fetch(`/api/${this.action}?lang=${lang}&page=${this.page}&hash=${this.hash}`, {
            method: 'GET',
            headers: {
                'X-csrf-token': _token
            },
        });

        let result = await response.json();

        this.error = result.error;
        this.items = Object.assign(this.items, result.items);
        this.loading = false;

        if (result.count == Object.keys(this.items).length) {
            this.buttonShow = false;
        }
    }
})
